// Libraries
import { TypeOf, z } from 'zod';
// Schemas
import { RatingsSchema } from './global';

const TypeTotalSchema = z.object({
  'Bulk Carrier': z.number().optional(),
  Tanker: z.number().optional(),
  'Gas Carrier': z.number().optional(),
  'Cargo Ship': z.number().optional(),
  'LNG Carrier': z.number().optional(),
  'Vehicles Carrier': z.number().optional(),
  Container: z.number().optional(),
});

const VesselTypesSchema = TypeTotalSchema.keyof();

const ShipDetailSchema = z.object({
  eoyRating: RatingsSchema,
  typeId: z.number(),
  type: VesselTypesSchema,
  ytdRating: RatingsSchema,
});

export type VesselDetail = TypeOf<typeof ShipDetailSchema>;

export type VesselTypes = TypeOf<typeof VesselTypesSchema>;
